import { useQuery } from '@tanstack/react-query';
import { FC, useMemo, useState } from 'react';
import styled from 'styled-components';

import ContentSpinner from '@/components/ContentSpinner';
import { VideoFactoryCategory, VideoFactorySettings } from '@/types/resources';
import { api } from '@/utils/api';
import { VideoFactorySettingsType } from '@/utils/enums';

import CategorySelection from './CategorySelection';
import SettingsCard from './SettingsCard';

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Settings: FC = () => {
  const [activeCategory, setActiveCategory] = useState<VideoFactoryCategory>({
    name: 'DEFAULT',
    id: null,
  });

  const { data } = useQuery({
    queryKey: ['video_factory_settings'],
    queryFn: () =>
      api.get<never, VideoFactorySettings[]>('/v1/video-factory/settings'),
  });

  const filtered = useMemo(() => {
    return data?.filter((d) => d.category_id === activeCategory.id) ?? [];
  }, [data, activeCategory]);

  if (!data) {
    return <ContentSpinner />;
  }

  return (
    <Grid>
      <CategorySelection
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />
      <SettingsCard
        activeCategory={activeCategory}
        settings={filtered}
        type={VideoFactorySettingsType.STORY_PROMPT}
      />
      <SettingsCard
        activeCategory={activeCategory}
        settings={filtered}
        type={VideoFactorySettingsType.SCRIPT_PROMPT}
      />
    </Grid>
  );
};

export default Settings;
